import React, { Component } from "react";
import { Link } from "react-router-dom";
import styles from "./styles.scss";
import CONFIG from "../../config";
import http from "../../helpers/http";
import WJSON from "../../helpers/json";
import WFirebase from "../../helpers/firebase";
import UserInfo from "../../helpers/userinfo";
import WSpinner from "../../components/WSpinner/WSpinner";
import WMask from "../../components/WMask/WMask";
import WModal from "../../components/WModal/WModal";
import img_public_utilities from "../../static/views/facility/img_public_utilities.png";

class Facility extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show_spinner: false,
      show_point_spinner: false,
      no_data: false,
      message: null,
      point: 0,
      total_point: 0,
      public_utilities: [],
    };
  }

  componentDidMount() {
    this.pullData();
  }

  pullData() {
    this.setState({ show_spinner: true, show_point_spinner: true });

    http.get(CONFIG.API_HOST + "api/v1.7/booking", {}, (state, res) => {
      this.setState({ show_spinner: false });

      const { code = 100, reason = "發生錯誤", data = {} } = res;

      if (state === false) {
        return this.setState({ message: "發生錯誤" });
      }

      if (code !== 200) {
        return this.setState({ message: reason });
      }

      const { public_utilities = [] } = data;

      this.setState({
        public_utilities: public_utilities,
        no_data: public_utilities.length === 0 ? true : false,
        //message: public_utilities.length === 0 ? '目前沒有資料':null,
      });
    });

    http.get(CONFIG.API_HOST + "api/v1.3/points", null, (state, res) => {
      this.setState({ show_point_spinner: false });

      const { code = 100, reason = "發生錯誤", data = {} } = res;

      if (state === false) {
        return this.setState({ message: "發生錯誤" });
      }

      if (code !== 200) {
        return this.setState({ message: reason });
      }

      const { points: { point = 0, addon_point = 0 } = {} } = data;

      this.setState({
        point: point,
        addon_point: addon_point,
        total_point: point + addon_point,
      });
    });
  }

  render() {
    const { total_point = 0 } = this.state;

    const items = this.state.public_utilities.map((item, i) => (
      <div
        key={i}
        className={styles.facility_item}
        style={{
          backgroundImage: `url(${item.pic ? item.pic : img_public_utilities})`,
        }}
        onClick={(e) => {
          // eslint-disable-next-line
          if (total_point == 0) {
            return WModal.show("已無點數，無法預約，請洽社區物管");
          }

          this.props.history.push("/booking?item=" + WJSON.encode(item));
        }}
      >
        <div className={styles.dark_area}></div>
        <div className={styles.title_area}>
          <div className={styles.title}>{item.name}</div>
          <div className={styles.points}>
            <div className={styles.point_text}>預約扣點：{item.point}點</div>
            <div className={styles.point_text}>
              {item.cleaning_point_type === "C" ? "清潔費" : "清潔扣點"}：
              {item.cleaning_point}
            </div>
          </div>
        </div>
      </div>
    ));

    return (
      <div className={styles.page_container}>
        <div className={styles.padding_container}>
          <div className={styles.total_area}>
            <div className={styles.col_12}>
              <div className={styles.title}>剩餘點數</div>
              <div className={styles.point}>
                {this.state.total_point}
                <span>點</span>
              </div>
            </div>
          </div>
          {items}
          {/* 我把兩個Mask整一起，不然兩個Mask一起出現會重疊 */}
          {(this.state.no_data || this.state.message) && (
            <WMask title={this.state.message ? this.state.message : ""}>
              {this.state.no_data && (
                <div>
                  <h1>目前暫無資料，請洽物管</h1>
                  <p>
                    如貴社區未使用社區雲
                    <br />
                    煩請管委會與我們聯繫
                  </p>
                </div>
              )}
            </WMask>
          )}
          {(this.state.show_spinner || this.state.show_point_spinner) && (
            <WMask>
              <WSpinner />
            </WMask>
          )}
        </div>
        <div className={styles.btn_box}>
          <Link to="/bookinglist">
            <button
              type="button"
              onClick={() => {
                if (UserInfo.houseid) {
                  WFirebase.logEvent("PublicUtilities", {
                    Mybooking: UserInfo.houseid,
                  });
                } else {
                  UserInfo.pullData((user) => {
                    WFirebase.logEvent("PublicUtilities", {
                      Mybooking: UserInfo.houseid,
                    });
                  });
                }
              }}
            >
              我的預約
            </button>
          </Link>
        </div>
      </div>
    );
  }
}

export default Facility;



// WEBPACK FOOTER //
// ./src/views/Facility/Facility.js